module.exports = {
  productionPlatform: 'android',
  socketServers: {
    server1: {
      url: 'http://localhost',
      port: 5000,
    },
  },
  apiServers:
    {
      url: 'https://api.ayrooapp.ir',
      port: 2500,
    },
  isCreator: false,
  isAppEmployee: false,
}
